import { request } from '../../api'
import { useServerFetch } from '../../composables/useServerFetch'

type WebHomeModulePayload = Record<string, unknown>

type WebHomeFeedbackCardPayload = Record<string, unknown>
export type WebHomeExchangeRankingLabel = {
  labelType?: number
  content?: string
  borderColor?: string
  backgroundColor?: string
  fontColor?: string
  image?: string
}

export type WebHomeExchangeRankingItem = {
  alias: any
  icoSquare: string
  slogan: string
  traderCode?: string
  localShortName?: string
  shortName?: string
  showName?: string
  fullName?: string
  logo?: string
  score?: string
  scoreIcon?: string
  isAdv?: boolean
  labels?: WebHomeExchangeRankingLabel[]
}

export type WebHomeExchangeRankingCategory = {
  code?: string
  name?: string
  englishName?: string
  list?: WebHomeExchangeRankingItem[]
}

export type WebHomeIndustryNewsTag = {
  tagcolor?: string
  tagname?: string
}

export type WebHomeIndustryNewsItem = {
  belongTabType?: number | string | null
  code?: string
  ico?: string | null
  imgurl?: string
  intro?: string
  languageid?: string
  name?: string | null
  tags?: WebHomeIndustryNewsTag[]
  title?: string
  traderCode?: string | null
  urlPath?: string
  wiki_timestamp?: number
}

export type WebHomeSurveyFeedbackMarketTradingResponse = {
  groups?: string[]
  rankingList?: WebHomeExchangeRankingCategory[]
  industryNews?: WebHomeIndustryNewsItem[]
  highRiskExposureAlert?: WebHomeModulePayload | WebHomeExchangeRankingCategory
  skyEyeSurvey?: WebHomeModulePayload
  feedback?: WebHomeModulePayload
  cryptoMarketData?: WebHomeModulePayload
  cryptoTradingVolumeRankings?: WebHomeModulePayload
}

export type WebHomeSurveyFeedbackMarketTradingApiResponse =
  | WebHomeSurveyFeedbackMarketTradingResponse
  | {
      code?: number
      message?: string
      succeed?: boolean
      data?: WebHomeSurveyFeedbackMarketTradingResponse
    }

export type GetWebHomeFeedbackRequest = {
  selectedTagType?: number
}

export type GetWebHomeFeedbackResponse = {
  title?: string
  selectedTagType?: number
  total?: number
  cards?: WebHomeFeedbackCardPayload[]
}

export type GetWebHomeFeedbackApiResponse =
  | GetWebHomeFeedbackResponse
  | {
      code?: number
      message?: string
      succeed?: boolean
      data?: GetWebHomeFeedbackResponse
    }

export type GetWebHomeTradingVolumeRankingsRequest = {
  page?: number
  pageSize?: number
}

export type GetWebHomeTradingVolumeRankingRow = Record<string, unknown>

export type GetWebHomeTradingVolumeRankingsResponse = {
  title?: string
  total?: number
  page?: number
  pageSize?: number
  rows?: GetWebHomeTradingVolumeRankingRow[]
}

export type GetWebHomeTradingVolumeRankingsApiResponse =
  | GetWebHomeTradingVolumeRankingsResponse
  | {
      code?: number
      message?: string
      succeed?: boolean
      data?: GetWebHomeTradingVolumeRankingsResponse
    }

export const getWebHomeSurveyFeedbackMarketTrading = () => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: '/api/v4/bit/web/home/survey-feedback-market-trading',
    method: 'GET',
  }

  return import.meta.server
    ? useServerFetch<WebHomeSurveyFeedbackMarketTradingApiResponse>(requestConfig)
    : request<WebHomeSurveyFeedbackMarketTradingApiResponse>(requestConfig)
}

export const getWebHomeFeedback = (params: GetWebHomeFeedbackRequest = {}) => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: '/api/v4/bit/web/home/feedback',
    method: 'GET',
    params,
  }

  return import.meta.server
    ? useServerFetch<GetWebHomeFeedbackApiResponse>(requestConfig)
    : request<GetWebHomeFeedbackApiResponse>(requestConfig)
}

export const getWebHomeTradingVolumeRankings = (params: GetWebHomeTradingVolumeRankingsRequest = {}) => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: '/api/v4/bit/web/home/trading-volume-rankings',
    method: 'GET',
    params,
  }

  return import.meta.server
    ? useServerFetch<GetWebHomeTradingVolumeRankingsApiResponse>(requestConfig)
    : request<GetWebHomeTradingVolumeRankingsApiResponse>(requestConfig)
}
